export default "__VITE_ASSET__Cvy0qV43__"